module.exports = __webpack_public_path__ + "2122164cd50177b089b80973b0b7058e.svg";